import {Component, OnDestroy, OnInit} from '@angular/core';
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {ItemProvider} from "../../../../core/pages/item/providers/item-provider/item-provider.service";
import {Events} from "../../../../framework/providers/events";
import {AppDataService} from "../../../../core/services/AppDataService";
import {MainService} from "../../../../core/services/MainService";
import {CashierService} from "../../services/cashierService";
import {AdminService} from "../../services/AdminService";

@Component({
    selector: 'app-cashier',
    templateUrl: './cashier.page.html',
    styleUrls: ['./cashier.page.scss'],
})
export class CashierPage implements OnInit, OnDestroy {
    constructor(public adminTools: ModelToolsProvider,
                public itemProvider: ItemProvider,
                public cashierService:CashierService,
                public events: Events,
                public adminService:AdminService,
                public appDataService: AppDataService, public mainService: MainService) {
    }

    ngOnInit() {
        // if (this.displayType.includes('items')) {
        let me = this;
        setTimeout(function () {
            me.adminService.closeMenu(null, true, true);
        }, 331);
        // }

    }

    ngOnDestroy() {
    }

}
